<mat-form-field [formGroup]="group" appearance="outline">
  <mat-label>{{ config.label }}</mat-label>
  <mat-date-range-input [rangePicker]="rangePicker">
    <input matStartDate [formControlName]="config.controlsDateRange?.start || 'startDate'" placeholder="Início" />
    <input matEndDate [formControlName]="config.controlsDateRange?.end || 'endDate'" placeholder="Fim" />
  </mat-date-range-input>

  <mat-datepicker-toggle matSuffix [for]="rangePicker"> </mat-datepicker-toggle>
  <mat-date-range-picker #rangePicker> </mat-date-range-picker>
</mat-form-field>
